import React, { useState, useEffect, memo } from 'react';
import CommonDatePicker from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import * as moment from 'moment';
import get from 'lodash/get';
import _ from 'lodash';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
const initialImg = '/images/icons/upload_new.svg';
const mb_reupload = '/images/icons/mb_upload.svg';
import {
  finalSanctionUpload,
  finalSanctionUploaded,
  UploadFileToS3,
  finalSanctionUpdateAPI,
  finalSanctionGETAPI
} from '../../../common/constants/api';
const file_icon = '/images/icons/CmDashIcons/file_icon.svg';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';
import PopUp from '../../../common/components/PopUp/PopUp';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../../common/utils/applicantionInfo';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import { numberFormat } from '../../../common/constants/NumberFormat';
import ShowDoc from '../../../containers/CMDashboard/ShowDoc';
import { enableGATracking } from 'gatsby-env-variables';

const validationSchema = Yup.object().shape({
  date: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  month: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  year: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  file: Yup.array().when('isEditMode', {
    is: false,
    then: Yup.array()
      .min(1, 'must upload 1 files atleast')
      .required('file is required')
      .of(Yup.string().required())
  }),

  imgUrl: Yup.string().when('isEditMode', {
    is: false, // alternatively: (val) => val == true
    then: Yup.string().required(' required')
  }),
  amount: Yup.number().required('required')
});

const FinalSanction = ({ setEnableBtn }) => {
  const [finalSanctionView, setFinalSanctionView] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [Edit1, setEdit1] = useState(false);
  const [imgLinkData, setImgLinkData] = useState(null);
  const [finalSanctionDocId, setFinalSanctionDocId] = useState('');
  const [getresponse, setResponse] = useState(false);
  const [getResponseCompleted, setgetResponseCompleted] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [loanAmount, setLoanAmount] = useState(
    parseInt(getApplicantionInfo()?.loanAmount) + 1 || 0
  );
  const [fullImage, setFullImage] = useState(false);

  return (
    <Formik
      initialValues={{
        isEditMode: false,
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: String(moment().format('YYYY')),
          label: String(moment().format('YYYY'))
        },
        file: [],
        imgUrl: [],
        amount: '',
        leadloanAmount: 0
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting,
        setValues
      }) => {
        let fullData = `${values?.date?.value} ${values?.month?.label} ${values?.year?.value}`;
        const updateLocalStorage = () => {
          let leadDetails = getApplicantionInfo();
          if (typeof leadDetails == 'object') {
            leadDetails['sanctionedAmount'] = values?.amount;
            setApplicantionInfo(leadDetails);
          } else {
            navigate('/app/dashboard');
          }
        };
        //upload
        async function fileUpload() {
          setType('loading');
          setText('Uploading the File Please Wait...');
          setShow(true);
          setDontClose(true);
          await finalSanctionUpload(getApplicantionInfo().leadId)
            .then(res => {
              setFinalSanctionDocId(res?.requestId);
              UploadFileToS3(res.url, values.file[0][0]).then(() => {
                finalSanctionUploaded(
                  getApplicantionInfo().leadId,
                  res?.requestId || ''
                ).then(res => {
                  setType('success');
                  setText('Uploaded the File successfully.');
                  setShow(true);
                  setDontClose(false);
                });
              });
            })
            .catch(err => {
              setShow(false);
            });
        }
        useEffect(() => {
          if (values.file[0] && values.file[0][0]) {
            fileUpload();
          }
        }, [values.file[0]]);

        ////update api
        const finalSanctionUpdateFun = () => {
          let body = {
            sanctionDate:
              values?.year?.value +
              '-' +
              (parseInt(values?.month?.value, 10) < 10
                ? '0' + parseInt(values?.month?.value, 10)
                : values?.month?.value) +
              '-' +
              (parseInt(values?.date?.value, 10) < 10
                ? '0' + parseInt(values?.date?.value, 10)
                : values?.date?.value),
            sanctionLetterDocId: finalSanctionDocId,
            finalSanctionAmount: values?.amount
          };
          setType('loading');
          setText('Please Wait while submitting data...');
          setShow(true);
          setDontClose(true);

          finalSanctionUpdateAPI(
            getApplicantionInfo().leadId,
            'final-sanction',
            body
          )
            .then(res => {
              setShow(false);
              setDontClose(false);

              setResponse(true);
              setFinalSanctionView(false);
              getfun();
              setEnableBtn(true);
              updateLocalStorage();
              if (enableGATracking) {
                ga(
                  'send',
                  'event',
                  'Button',
                  'Click',
                  'Sanctioned',
                  values?.amount,
                  { sanctionedAmount: values?.amount }
                );
              }
            })
            .catch(err => {
              setShow(false);
            });
        };

        function getfun() {
          setType('loading');
          setText('Please wait while retrieving data...');
          setShow(true);
          setDontClose(true);

          finalSanctionGETAPI(getApplicantionInfo().leadId, 'final-sanction')
            .then(res => {
              if (res.finalSanctionDetails && res.sanctionLetterDoc) {
                setResponse(true);
              }

              let formatDate = res?.finalSanctionDetails?.sanctionDate;
              setImgLinkData(res?.sanctionLetterDoc?.url);
              setFinalSanctionDocId(
                res?.finalSanctionDetails?.sanctionLetterDocId
              );
              setValues({
                ...values,
                isEditMode: res?.sanctionLetterDoc?.url ? true : false,
                date: {
                  value: formatDate ? moment(formatDate).format('DD') : '',
                  label: formatDate ? moment(formatDate).format('DD') : 'Date'
                },
                month: {
                  value: formatDate ? moment(formatDate).format('MM') : '',
                  label: formatDate
                    ? moment(formatDate).format('MMMM')
                    : 'Month'
                },
                year: {
                  value: moment(formatDate).format('YYYY'),
                  label: moment(formatDate).format('YYYY')
                },
                amount: res?.finalSanctionDetails?.finalSanctionAmount,
                leadloanAmount: loanAmount
              });
              setgetResponseCompleted(true);
              setShow(false);
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
              setgetResponseCompleted(true);
            });
        }
        //get all data
        useEffect(() => {
          getfun();
        }, []);

        return (
          <React.Fragment>
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 sm:px-5 "
            >
              <div className="font-medium mb-3 text-base">Final Sanction</div>
              {(finalSanctionView || !getresponse) && getResponseCompleted && (
                <>
                  <div className="w-12/12 lg:block">
                    <div className="   lg:pr-0 mt-8 lg:mt-5 w-full lg:w-8/12 xl:w-6/12 my-5">
                      <InputTypeNumber
                        name="amount"
                        maxLength={10}
                        minLength={0}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.amount}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Sanction Amount"
                        error={touched.amount && errors.amount}
                        errorMsg={errors.amount}
                        touched={touched.amount}
                        showInText={false}
                        setFieldValue={setFieldValue}
                      />
                    </div>

                    <div className="w-full lg:w-8/12 xl:w-6/12">
                      <p>Sanction date</p>
                      <CommonDatePicker
                        datePickerContainerstyle={{
                          height: '52px'
                        }}
                        dropdownStyle={{
                          marginTop: '10px'
                        }}
                        onChangeMonth={(value, isValidDate) => {
                          setFieldValue('month', value, true);
                          setFieldTouched('month', true, false);
                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeYear={(value, isValidDate) => {
                          setFieldValue('year', value, true);
                          setFieldTouched('year', true, false);

                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeDate={value => {
                          setFieldValue('date', value, true);
                          setFieldTouched('date', true, false);
                        }}
                        valueMonth={values.month}
                        valueYear={values.year}
                        valueDate={values.date}
                        errorYear={
                          touched.year && get(errors, 'year.value', false)
                        }
                        touchedYear={touched.year}
                        onBlurYear={() => {
                          setFieldTouched('year', true, true);
                        }}
                        errorMonth={
                          touched.month && get(errors, 'month.value', false)
                        }
                        touchedMonth={touched.month}
                        onBlurMonth={() => {
                          setFieldTouched('month', true, true);
                        }}
                        // errors.date.value
                        errorDate={
                          touched.date && get(errors, 'date.value', false)
                        }
                        touchedDate={touched.date}
                        onBlurDate={() => {
                          setFieldTouched('date', true, true);
                        }}
                        errorMsg=""
                      />
                    </div>
                  </div>
                  <div className="mt-10">
                    <p className="font-medium mb-3 text-base">
                      Upload Sanction letter
                    </p>
                    <div
                      className="bg-white  flex justify-center rounded-lg border border-navy-200 md:border-none
                        py-9  pr-5 pl-8  md:py-0 md:pl-0 md:pr-0 w-64 md:w-full"
                    >
                      {imgLinkData && !Edit1 ? (
                        <div className="md:mr-auto md:ml-3 ">
                          <ShowGetImage img={imgLinkData} setEdit={setEdit1} />
                        </div>
                      ) : (
                        <GlobalUploadComp
                          data={values}
                          imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          initialImg={initialImg}
                          subInst="Click here or drop here to upload"
                          subtext="CHOOSE IMAGE"
                        />
                      )}
                    </div>
                  </div>
                  <button
                    id="lems_sanctionSubmitBtn"
                    type="submit"
                    onClick={() => {
                      finalSanctionUpdateFun();
                    }}
                    disabled={
                      !_.isEmpty(errors) ||
                      values.date.value == '' ||
                      values.month.value == '' ||
                      values.year.value == ''
                    }
                    className={
                      ' submitButton text-14 w-56 h-12 font-medium  font-roboto'
                    }
                  >
                    Submit
                  </button>
                </>
              )}
              {!finalSanctionView && getresponse && getResponseCompleted && (
                <div
                  className="bg-orange-200 pl-1 rounded relative"
                  style={{ width: '300px' }}
                >
                  <div className="bg-navy-700 p-4 rounded-r">
                    <div className="w-full flex">
                      <div className="block w-6/12">
                        <div className="font-roboto font-normal text-black-500 bg-blue-1150 text-xs">
                          Sanction date :
                        </div>
                        <div className="font-roboto font-bold text-black-500 text-sm">
                          {fullData}
                        </div>
                      </div>
                      <div className="block w-6/12">
                        <div className="font-roboto font-normal text-black-500 bg-blue-1150 text-xs">
                          Sanction Loan Amount :
                        </div>
                        <div className="font-roboto font-bold text-black-500 text-sm">
                          &#8377;
                          {numberFormat(values?.amount || 0)}
                        </div>
                      </div>
                    </div>
                    <div
                      className="flex text-green-1350 mt-3 cursor-pointer"
                      onClick={() => setFullImage(true)}
                    >
                      <img src={file_icon} alt="" />
                      <span className="pl-1"> Sanction letter</span>
                    </div>
                  </div>
                </div>
              )}
            </Form>
            <ShowDoc
              file={imgLinkData}
              show={fullImage}
              setShow={setFullImage}
              autoCheck={true}
            />

            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              dontClose={dontClose}
              autoClose={type === 'success'}
            />
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default memo(withErrorHandler(FinalSanction));
